import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { SchoolActivityInstance } from '../../../models';
import { BulkSignUpForActivityAction } from '../../school-activity-attendees/actions/school-activity-attendees.actions';
import {
	AddSchoolActivityInstanceAction,
	ClearSelectedActivityInstanceAction,
	CreateSchoolActivityInstancesBulkSuccessActionV2,
	GetSchoolActivityInstancesForActivitySuccessAction,
	GetSchoolActivityInstancesForFlexPeriodSuccessAction,
	GetSchoolActivityInstancesSuccessAction,
	RemoveSchoolActivityInstanceSuccessAction,
	SelectActivityInstanceAction,
	UpdateSchoolActivityInstanceSuccessAction,
} from '../actions/school-activities-instances.actions';

export interface SchoolActivityInstancesState extends EntityState<SchoolActivityInstance> {
	selectedActivityInstanceId: number | null;
}

export const schoolActivityInstancesInitialState: SchoolActivityInstancesState = {
	ids: [],
	entities: {},
	selectedActivityInstanceId: null,
};

export const schoolActivityInstanceAdapter: EntityAdapter<SchoolActivityInstance> = createEntityAdapter<SchoolActivityInstance>();

export const schoolActivitiesInstancesReducer = createReducer(
	schoolActivityInstancesInitialState,
	on(GetSchoolActivityInstancesSuccessAction, (state, { instances }) => schoolActivityInstanceAdapter.upsertMany(instances, state)),
	on(GetSchoolActivityInstancesForFlexPeriodSuccessAction, (state, { instances }) => schoolActivityInstanceAdapter.upsertMany(instances, state)),
	on(RemoveSchoolActivityInstanceSuccessAction, (state, { instanceId }) => {
		return schoolActivityInstanceAdapter.removeOne(instanceId, state);
	}),
	on(SelectActivityInstanceAction, (state, { instanceId }) => ({
		...state,
		selectedActivityInstanceId: instanceId,
	})),
	on(ClearSelectedActivityInstanceAction, (state) => ({
		...state,
		selectedActivityInstanceId: null,
	})),
	on(AddSchoolActivityInstanceAction, (state, { instance }) => schoolActivityInstanceAdapter.addOne(instance, state)),
	on(UpdateSchoolActivityInstanceSuccessAction, (state, { instance }) => schoolActivityInstanceAdapter.upsertOne(instance, state)),

	// Add multiple activities and select the first newly added record
	on(CreateSchoolActivityInstancesBulkSuccessActionV2, (state, { instances }) => {
		if (instances.length === 0) {
			return state;
		}
		return {
			...schoolActivityInstanceAdapter.upsertMany(instances, state),
			selectedActivityInstanceId: instances[0].id,
		};
	}),
	on(GetSchoolActivityInstancesForActivitySuccessAction, (state, { activityId, instances }) => {
		// Since we fetched all activity instances for this activity, remove all the existing ones
		// and replace them.
		const filteredState = schoolActivityInstanceAdapter.removeMany((instance) => instance.activity_id === activityId, state);
		return schoolActivityInstanceAdapter.upsertMany(instances, filteredState);
	}),
	on(BulkSignUpForActivityAction, (state, { req, instance, checkIn }) => {
		if (instance.current_num_attendees !== undefined) {
			instance.current_num_attendees = instance.current_num_attendees + req.user_ids.length;
		} else if (instance.current_num_attendees === undefined) {
			instance.current_num_attendees = req.user_ids.length;
		}
		return schoolActivityInstanceAdapter.upsertOne(instance, {
			...state,
			selectedActivityInstanceId: instance.id,
		});
	})
);
